<i class="fas fa-bars fs-24px fc-secondary" (click)="globalVars.isLeftBarMobileOpen = true"></i>
